import React from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";

import {
  PubSubKeys,
  TicketStatuses,
} from "../../../../store/constants";
import { completeTicket } from "../../../../store/actions/ticketsActions";

function CompleteTicket({type, ticketId = null, supervisorOverride = false}) {
  const dispatch = useDispatch();
  const hostname = useSelector(state => state.auth.hostname);
  const tickets = useSelector(state => state.tickets.tickets);
  const activeTicketId = useSelector(state => state.tickets.activeTicketId);
  const activeManagementTicketId = useSelector(state => state.tickets.activeManagementTicketId);
  const authenticatedUser = useSelector(state => state.auth.authenticatedUser);
  const targetTicketId = ticketId || (supervisorOverride ? activeManagementTicketId : activeTicketId);

  const manageTicket = (ticketData) => {
    if (ticketData == null || targetTicketId == null) {
      console.log("can't use action");
      return;
    }

    if (supervisorOverride && !window.confirm(`Complete Ticket ${ticketData.ticketLetter}-${ticketData.ticketNumber} for another agent?`)) {
      return;
    }

    const action = "completeTicket";
    const sessionInSeconds = dayjs().unix();
    const ticket = {
      ...ticketData,
      sessionEnd: sessionInSeconds,
      sessionInSeconds: sessionInSeconds - Number(ticketData.sessionStart),
      status: TicketStatuses[action], //status code for action
      redZone: supervisorOverride ? {
        action: "complete",
        supervisorUserId: authenticatedUser.id,
        originalAgentUserId: ticketData.manage ? ticketData.manage.userId : null,
        created: sessionInSeconds
      } : ticketData.redZone,
    };

    const payload = {
      ...PubSubKeys[action],
      msg: {
        ticket,
        supervisorOverride,
      },
    };
    dispatch(completeTicket(hostname, payload));
  };

  const ticket = tickets.find((data) => data.id === targetTicketId);

  const content = type === 'default'
  ? (
    <div
      className="home-left-content2-item item2 call-completed"
      onClick={() => manageTicket(ticket)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="63"
        fill="none"
        viewBox="0 0 60 63"
      >
        <circle
          cx="30.5"
          cy="17.5"
          r="14.5"
          stroke="#1BB79F"
          strokeWidth="4.287"
        />
        <path
          stroke="#1BB79F"
          strokeWidth="4.287"
          d="M3 60c0-15.464 12.088-28 27-28"
        />
        <path
          stroke="#1BB79F"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="3.131"
          d="M57 42L40.9 60 34 53.25"
        />
      </svg>

      <h4>Completed</h4>
    </div>
  )
  : (
    <div className="actionButtonContainer">
        <div
          className="actionButton scheme-green-bg"
          onClick={() => manageTicket(ticket)}
        >
          <div>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M23.9506 4.30885L23.9082 3.64182L23.2461 3.52417C18.612 2.69796 16.6775 2.10066 12.353 0.159705L12 0L11.647 0.159705C7.32252 2.10066 5.388 2.69796 0.753915 3.52417L0.0917502 3.64182L0.0494273 4.30885C-0.15683 7.56205 0.283006 10.5933 1.35822 13.3184C2.23871 15.5412 3.54176 17.5747 5.1962 19.3079C8.06076 22.3279 11.1021 23.6396 11.6823 23.8717L12.0038 24L12.3252 23.8717C12.9054 23.6396 15.9467 22.3279 18.8113 19.3079C20.4631 17.5741 21.7635 15.5406 22.6418 13.3184C23.717 10.5933 24.1568 7.56205 23.9506 4.30885V4.30885ZM10.4014 15.8076L6.50178 12.0088L7.70182 10.7918L10.2985 13.32L16.1985 6.54846L17.495 7.6632L10.4014 15.8076Z" />
            </svg>
          </div>
          <span>Completed</span>
        </div>
      </div>
  )

  return content
}

export default CompleteTicket;
